<template>
    <div class="test-examinee">
        <el-card shadow="never">
            <div slot="header" class="clearfix">
                <span>考生设置</span>
            </div>
            <div>
                <el-tree
                    ref="tree"
                    show-checkbox
                    node-key="deptId"
                    :data="deptList"
                    :props="defaultProps"
                    @check="handleCheck"
                >
                    <!-- <div class="custom-tree-node" slot-scope="{ node, data }">
						<span>{{node}}{{data}}</span>
                    </div>-->
                </el-tree>
                <br />
                <el-row style="text-align:right">
                    <el-button @click="$router.go(-1)">上一步</el-button>
                    <el-button type="primary" @click="handleSave">保存</el-button>
                </el-row>
            </div>
        </el-card>
    </div>
</template>
<script>
import { arrToTree } from '@/utils/system/dept'
import { getDeptTree } from '@/api/system/dept'
export default {
    data () {
        return {
            deptList: [],
            defaultProps: {
                label: 'name'
            },
            checkedNodes: []
        };
    },
    watch: {
        '$route' (to) {
            if (to.path == '/test/newTest/add/set') {
                this.$router.push({ 'path': '/test/newTest/add/creat' })
            }
        }
    },
    computed: {
        deptIds: function () {
            let arr = []
            this.checkedNodes.map(item => {
                arr.push(item.deptId)
            })
            return arr
        }
    },
    methods: {
        init () {
            this.getDeptTree()
        },
        // 获取部门tree结构
        getDeptTree () {
            getDeptTree().then(res => {
                let { deptList } = res
                this.deptList = arrToTree(deptList)
            })
        },
        // 当复选框被点击的时候触发
        handleCheck () {
            let treeDom = this.$refs['tree'];
            let arr = []
            if (treeDom) {
                arr = treeDom.getCheckedNodes(true)
            }
            this.checkedNodes = arr
        },
        handleSave () {
            let deptIds = this.deptIds
            this.$emit('submit', { deptIds })
        }
    },
    created () {
        this.init();
    }
};
</script>
<style lang="less">
.test-examinee {
    .el-dialog__header {
        padding: 20px;
        text-align: center;
        border: 1px solid #dcdcdc;
    }
    .el-dialog__footer {
        padding: 20px;
        border-top: 1px solid #dcdcdc;
    }
    .el-transfer-panel {
        width: 250px;
    }
    .examiner-list {
        padding: 10px 20px;
        .el-checkbox {
            background-color: #f0f0f0;
            padding: 10px;
            width: 100%;
            span:nth-of-type(2) {
                margin: 0 120px 0 80px;
            }
        }
    }
}
</style>

<style lang="less" scoped>
.test-examinee {
    .allCheck {
        position: absolute;
        top: -40px;
        left: 30px;
    }
    .examiner {
        overflow: hidden;
        li {
            float: right;
            font-size: 14px;
            margin-left: 30px;
        }
    }
}
</style>

